<template>
  <div class="container-fluid">
    <div class="row mt-5">
      <div class="col-auto">
        <el-date-picker
          v-model="fromTo"
          format="dd.MM.yyyy"
          value-format="yyyy-MM-dd"
          type="daterange"
          align="left"
          unlink-panels
          range-separator="do"
          start-placeholder="Začátek"
          end-placeholder="Konec"
          @change="getExList"
          :default-value="dateForDatePicker"
          :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <div class="col-auto ml-auto" v-if="exList.length && downloadExcel">
        <el-button type="primary" icon="el-icon-document" @click="download">Stáhnout .xlsx</el-button>
      </div>
    </div>
    <el-table v-loading="loading" class="mt-5" stripe :data="exList" style="width: 100%" height="calc(100vh - 350px)">
      <el-table-column fixed prop="cisloNominace" label="Číslo nominance" width="150"></el-table-column>
      <el-table-column label="Datum od" width="100">
        <template slot-scope="scope">
          {{moment(scope.row.datumOd).format('DD.MM.YYYY')}}
        </template>
      </el-table-column>
      <el-table-column prop="typ" label="Typ" width="80"></el-table-column>
      <el-table-column prop="podtyp" label="Podtyp"></el-table-column>
      <el-table-column prop="sz" label="SZ" width="290"></el-table-column>
      <el-table-column prop="provozovatel" label="Provozovatel" width="200"></el-table-column>
      <el-table-column prop="opm" label="OPM" width="200"></el-table-column>
      <el-table-column prop="nazevOPM" label="Název OPM" width="150"></el-table-column>
      <el-table-column prop="protistrana" label="Protistrana" width="130"></el-table-column>
      <el-table-column prop="smer" label="Směr"></el-table-column>
      <el-table-column prop="celNomMnozstvi" label="Celk. nom. množství" width="200"></el-table-column>
      <el-table-column prop="puvodniNomHodnota" label="Původní nom. hodnota" width="200"></el-table-column>
      <el-table-column label="Datum přijetí" width="150">
        <template slot-scope="scope">
          {{moment(scope.row.datumCasPrijeti).format('DD.MM.YYYY')}}
        </template>
      </el-table-column>
      <el-table-column label="Čas přijetí" width="150">
        <template slot-scope="scope">
          {{moment(scope.row.datumCasPrijeti).format('HH:mm:ss')}}
        </template>
      </el-table-column>
      <el-table-column fixed="right" prop="status" label="Status"></el-table-column>
    </el-table>

    <div class="mt-5 mb-5">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pagination.pageSize"
        :current-page.sync="pagination.pageNumber"
        :total="pagination.total"
        @current-change="getExList"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "Data",
  data() {
    return {
      loading: false,
      exList: [],
      pagination: {
        pageSize: 10,
        pageNumber: 1,
        total: 1
      },
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: 'Poslední týden',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Měsíc',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '3 měsíce',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      fromTo: null,
    };
  },
  methods: {
    getExList() {
      let options = {
        pagination: this.pagination,
        fromTo: this.fromTo,
      }
      this.loading = true
      this.$store.dispatch('getExList', { options })
        .then(response => {
          this.exList = response.data
          this.pagination.total = JSON.parse(response.headers['x-pagination']).totalCount
          this.loading = false
        })
    },
    download() {
      let date = this.moment(new Date()).format('DD.MM.YYYY-H:mm')
      this.$http.get(
        this.downloadExcel,
        {
          headers: {
            Accept: 'text/xlsx'
          },
          responseType: 'blob',
          timeout: 30000
        })
        .then(response => {
          var blob = new Blob([response.data], {type: response.data.type || 'application/octet-stream'})
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
              window.navigator.msSaveBlob(blob, date + '.xlsx');
          }
          else {
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', date + '.xlsx')
            document.body.appendChild(link)
            link.click()
            link.remove()
          }
        })
    }
  },
  computed: {
    dateForDatePicker() {
      return this.moment().subtract(1, 'months').format('YYYY-MM-DD');
    },
    downloadExcel() {
      if (this.fromTo) {
        return `excellines/export?from=${this.fromTo[0]}&to=${this.fromTo[1]}`
      } return false
    },
  },
  created() {
    this.getExList()
  }
};
</script>

<style>
.el-date-editor .el-range-separator {
  width: 10%;
}
</style>
